var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"message-product",attrs:{"href":_vm.link,"target":"_blank","title":"Открыть товар"}},[_c('div',{staticClass:"message-product-image"},[_c('img',{attrs:{"src":_vm.data.picture,"alt":_vm.data.name}})]),_c('div',{staticClass:"message-product-title"},[_vm._v(_vm._s(_vm.data.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }